import { inject, Injectable } from "@angular/core";
import { ActivatedRouteSnapshot, CanActivate, Router } from "@angular/router";
import { AccessRoleEnum } from "@services/business/_models/roles";
import { BeUsersService } from "@services/business/user-services/be-users.service";
import { from, Observable, of } from "rxjs";
import { catchError, map } from "rxjs/operators";

@Injectable({
  providedIn: "root",
})
export class RoleGuard implements CanActivate {
  private usersService = inject(BeUsersService);
  private router = inject(Router);

  canActivate(route: ActivatedRouteSnapshot): Observable<boolean> {
    const requiredRoles = (route.data["roles"] as AccessRoleEnum[]) ?? [];
    const excludedRoles =
      (route.data["excludedRoles"] as AccessRoleEnum[]) ?? [];

    if (
      (!requiredRoles || requiredRoles.length === 0) &&
      (!excludedRoles || excludedRoles.length === 0)
    ) {
      return of(true);
    }

    return from(this.usersService.loadRoles()).pipe(
      map((roles: AccessRoleEnum[]) => {
        if (!roles || roles.length === 0) {
          this.router.navigate(["/login"]);
          return false;
        }

        const hasRequiredRole = requiredRoles.some(role =>
          roles.includes(role)
        );

        if (requiredRoles.length > 0 && !hasRequiredRole) {
          this.router.navigate(["/login"]);
          return false;
        }

        const hasExcludedRole = excludedRoles.some(role =>
          roles.includes(role)
        );

        if (hasExcludedRole) {
          this.router.navigate(["/login"]);
          return false;
        }

        return true;
      }),
      catchError(() => {
        this.router.navigate(["/login"]);
        return of(false);
      })
    );
  }
}
